import { createBrowserRouter } from 'react-router-dom';

import {
  DESKTOP_ROUTES_CONFIG,
  ROUTES_CONFIG,
} from '@/shared/config/router/routes-config';

export const makeRouter = (isDesktop = false) =>
  createBrowserRouter(isDesktop ? DESKTOP_ROUTES_CONFIG : ROUTES_CONFIG);
